<template>
  <div class="logo-background order-1 order-xl-2">
    <a :href="url" :title="title">
      <img class="logo" :src="image" />
    </a>
  </div>
</template>

<script>
export default {
  name: "fcwpLogo",
  props: ["url", "image", "title"],
};
</script>

<style lang="scss">

.logo-background {
  background: rgb($quaternary-color);
  width: 28.6vw;
  max-height: 8.3vw;
  // position: relative;
  margin: 0 0 0 0.5vw;
  z-index: 15;
  padding-top: 1.17vw;
  padding-bottom: 2.34vw;
}
img.logo {
  width: 75%;
  margin-left: auto;
  margin-right: auto;
  display: block;
  // margin-top: 1.17vw;
  // margin-bottom: 1.17vw;
}

@media (max-width: 1199px) {
  .logo-background {
    margin-left: auto;
    margin-right: auto;
    width: 343px;
    // height: calc(76px + 2.34vw);
    max-height: unset;
  }
  img.logo {
    // margin-top: 14px;
  }
}

@media (max-width: 700px) {
  img.logo {
    max-width: 258px;
    // height: 100%;
    // width: auto;
  }

  .logo-background {
    width: 100%;
    padding-top: 10px;
    padding-bottom: calc(10px + 1.17vw);
    // height: 100px;
  }
}

@media (max-width: 290px) {
  .logo-background {
    display: table;
  }
  .logo-background a {
    display: table-cell;
    vertical-align: middle;
  }

  img.logo {
    // margin-top: initial;
    width: 90vw;
    height: auto;
  }

  .logo-background {
    width: 100%;
    height: auto;
  }
}
</style>

